// extracted by mini-css-extract-plugin
export default {"root":"Header_root__2bNVY","transparent":"Header_transparent__I8R4y","navLink":"Header_navLink__dLKV9"};